export default __webpack_public_path__ + "static/Video-See-How-BlueRI-for-Duals-Helps-7e34be0d011fdc2507e9bf6b33143cbf.jpg";